import { Users } from '@griply/assets';
import { CalendarEventGuest, ExternalConnectionContact } from '@griply/types';
import { CalendarEventGuestListEntry } from '@griply/utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormGuestInput } from 'shared/components/ui/form-guest-input';

import { EventRow } from '../event-row';

export type EventGuestsRowProps = {
  // read-only callers pass the merged list, which badges the organizer
  value: (CalendarEventGuest | CalendarEventGuestListEntry)[];
  contacts?: ExternalConnectionContact[];
  disabled?: boolean;
  isLoading?: boolean;
  onChange?: (guests: CalendarEventGuest[]) => void;
};

export const EventGuestsRow: React.FC<EventGuestsRowProps> = ({
  value,
  contacts,
  disabled,
  isLoading,
  onChange,
}) => {
  const { t } = useTranslation();

  // the chip list without its remove buttons and draft input IS the read-only form
  const isReadOnly = !!disabled || !onChange;

  return (
    <EventRow icon={Users} isLoading={isLoading} alignTop>
      <FormGuestInput
        value={value}
        onChange={onChange}
        contacts={contacts}
        readOnly={isReadOnly}
        placeholder={t('forms.event.fields.guests.placeholder')}
        error={t('forms.event.fields.guests.invalid')}
      />
    </EventRow>
  );
};
